(() => {
  const desktop = window.matchMedia('(min-width: 1200px)');
  const initialize = () => {
    document.querySelectorAll('.header .list-menu--inline > li').forEach(item => {
      const panel = item.querySelector(':scope > .header-mega-menu');
      const trigger = item.querySelector(':scope > .header__menu-item');
      if (!panel || !trigger || item.hasAttribute('data-mega-ready')) return;
      item.setAttribute('data-mega-ready', '');
      trigger.setAttribute('aria-expanded', 'false');
      let closeTimer;
      let firstTouch = false;
      const close = () => {
        clearTimeout(closeTimer);
        item.classList.remove('is-mega-open');
        trigger.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        item.parentElement.querySelectorAll(':scope > .is-mega-open').forEach(other => {
          if (other !== item) other.dispatchEvent(new Event('mega:close'));
        });
        item.classList.add('is-mega-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      item.addEventListener('mega:close', close);
      item.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') open();
      });
      item.addEventListener('pointerleave', () => {
        closeTimer = setTimeout(() => {
          if (!item.contains(document.activeElement)) close();
        }, 240);
      });
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget) && !item.matches(':hover')) close();
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          trigger.focus();
          close();
          event.preventDefault();
        }
      });
      trigger.addEventListener('pointerdown', event => {
        firstTouch = desktop.matches && event.pointerType === 'touch' && !item.classList.contains('is-mega-open');
        if (firstTouch) {
          open();
        }
      });
      trigger.addEventListener('click', event => {
        if (firstTouch) {
          event.preventDefault();
          firstTouch = false;
        }
      });
      document.addEventListener('pointerdown', event => {
        if (!item.contains(event.target)) close();
      });
      desktop.addEventListener('change', close);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
